// ═══════════════════════════════════════════════════════════════
// BUNDLE 2 — selectColorSwatch2 + updateVariantId2
// ═══════════════════════════════════════════════════════════════

function selectColorSwatch2(swatch) {
  const container = swatch.closest('.bundle-dropdown-item2');
  const colorInput = container.querySelector('.color-select');
  const allSwatches = container.querySelectorAll('.color-swatch');

  allSwatches.forEach(s => {
    s.style.border = '2px solid #ddd';
    s.style.transform = 'scale(1)';
  });

  swatch.style.border = '2px solid #004537';
  swatch.style.transform = 'scale(1.1)';

  colorInput.value = swatch.getAttribute('data-color');
  updateVariantId2(container);
}

function updateVariantId2(element) {
  const container = element.closest
    ? element.closest('.bundle-dropdown-item2')
    : element;

  const sizeSelect    = container.querySelector('.size-select');
  const colorInput    = container.querySelector('.color-select');
  const variantDataEl = container.querySelector('.variant-data2');
  const imageElement  = container.querySelector('.bundle-item-image img');

  if (!sizeSelect || !colorInput || !variantDataEl) return;

  let variantData = {};
  try { variantData = JSON.parse(variantDataEl.textContent); } catch(e) { return; }

  const selectedSize  = sizeSelect.value;
  const selectedColor = colorInput.value;
  const combinedKey   = selectedSize + ' / ' + selectedColor;
  const variantInfo   = variantData[combinedKey];

  if (!variantInfo) {
    console.warn('No matching variant for:', combinedKey);
    return;
  }

  container.setAttribute('data-variant-id', variantInfo.id);
  container.setAttribute('data-price', variantInfo.price);

  const priceEl = container.querySelector('.bundle-item-sale-price');
  if (priceEl) {
    priceEl.textContent = '$' + (parseInt(variantInfo.price) / 100).toFixed(2);
  }

  if (imageElement && variantInfo.image && variantInfo.image !== 'null') {
    const newImageUrl = variantInfo.image
      .replace('.jpg', '_150x.jpg')
      .replace('.png', '_150x.png');
    imageElement.src    = newImageUrl;
    imageElement.srcset = '';
    imageElement.alt    = selectedColor + ' - ' + selectedSize;
  }

  const dropdown = container.closest('.bundle-dropdown2');
  if (dropdown) {
    container.dispatchEvent(new CustomEvent('bundle:variantChanged2', {
      bubbles: true,
      detail: {
        productType: dropdown.dataset.productType,
        newVariantId: variantInfo.id,
        newPrice: parseFloat(variantInfo.price),
      }
    }));
  }

  console.log('Updated →', combinedKey, 'Variant:', variantInfo.id);
}


// ═══════════════════════════════════════════════════════════════
// BUNDLE 2 — Main JS
// ═══════════════════════════════════════════════════════════════

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('.bundle-dropdown-item2').forEach(item => {
    const firstSwatch = item.querySelector('.color-swatch');
    if (firstSwatch) {
      firstSwatch.style.border = '2px solid #004537';
      firstSwatch.style.transform = 'scale(1.1)';
    }
  });

  const elements2 = {
    bundleSelector: document.querySelector(".bundle-selector2"),
    dropdowns: document.querySelectorAll(".bundle-dropdown2"),
    totalPrice: document.getElementById("bundle-total-price2"),
    quantity: {
      input: document.querySelector(".bundle-quantity-input2"),
      decrease: document.querySelector(".bundle-quantity-decrease2"),
      increase: document.querySelector(".bundle-quantity-increase2"),
    },
    addToCart: document.querySelector(".bundle-add-to-cart2"),
    buyNow: document.querySelector(".bundle-buy-now2"),
    savings: {
      progress: document.querySelector(".bundle-savings-progress2"),
      marker: document.querySelector(".bundle-savings-marker2"),
      amount: document.querySelector(".bundle-savings-amount2"),
    },
    addToBundleButtons: document.querySelectorAll(".add-to-bundle-btn2"),
  };

  const state = {
    basePrice: parseFloat(elements2.bundleSelector.dataset.basePrice || 0),
    maxSavings: parseFloat(elements2.bundleSelector.dataset.maxSavings) || 100,
    selectedItems: new Map(),
    confirmedDropdowns: new Set(),
    bundleComplete: false,
    totalSavings: 0,
  };

  // ─────────────────────────────────────────────────────────────
  // ✅ PREORDER: property helper — bundle 1 jaise same pattern
  // ─────────────────────────────────────────────────────────────
 function getPreorderProperty() {
  const checkbox = document.getElementById('preorder-agree');
  if (!checkbox || !checkbox.checked) return null;
  
  // Global variable se message lo
  return window.ShopifyTheme.preorderMessage || null;
}

  // ─────────────────────────────────────────────────────────────
  // ✅ Inventory check — bundle 1 jaise same
  // ─────────────────────────────────────────────────────────────
  function getMainVariantInventoryPolicy() {
    const form = document.querySelector('.bundleform2');
    if (form && form.dataset.inventoryPolicy) {
      return {
        policy:   form.dataset.inventoryPolicy,
        quantity: parseInt(form.dataset.inventoryQuantity || '0'),
      };
    }

    const sel = elements2.bundleSelector;
    if (sel && sel.dataset.inventoryPolicy) {
      return {
        policy:   sel.dataset.inventoryPolicy,
        quantity: parseInt(sel.dataset.inventoryQuantity || '0'),
      };
    }

    const hiddenInput = document.querySelector('.bundleform2 input[name="id"]');
    const productJson = document.querySelector('[data-product-json]');
    if (hiddenInput && productJson) {
      try {
        const product  = JSON.parse(productJson.textContent);
        const variant  = product.variants.find(v => v.id == hiddenInput.value);
        if (variant) {
          return {
            policy:   variant.inventory_management ? variant.inventory_policy : 'continue',
            quantity: variant.inventory_quantity,
          };
        }
      } catch(e) {}
    }

    return { policy: 'continue', quantity: 1 };
  }

  function isMainVariantAvailable() {
    const { policy, quantity } = getMainVariantInventoryPolicy();
    if (policy === 'continue') return true;
    return quantity > 0;
  }

  function getMainVariantId() {
    if (elements2.bundleSelector.dataset.variantId) {
      return parseInt(elements2.bundleSelector.dataset.variantId);
    }
    const hiddenInput = document.querySelector('.bundleform2 input[name="id"]');
    return hiddenInput ? parseInt(hiddenInput.value) : null;
  }

  function updateBasePriceFromForm() {
    const hiddenInput = document.querySelector('.bundleform2 input[name="id"]');
    if (!hiddenInput) return;
    const variantId = hiddenInput.value;

    const variantOption = document.querySelector(`.bundleform2 option[value="${variantId}"]`);
    if (variantOption && variantOption.dataset.price) {
      state.basePrice = parseFloat(variantOption.dataset.price);
      updateTotalPrice();
      return;
    }

    const formElement = document.querySelector(".bundleform2");
    if (formElement && formElement.dataset.variantPrice) {
      state.basePrice = parseFloat(formElement.dataset.variantPrice);
      updateTotalPrice();
      return;
    }

    const productJson = document.querySelector("[data-product-json]");
    if (productJson) {
      try {
        const product = JSON.parse(productJson.textContent);
        const variant = product.variants.find((v) => v.id == variantId);
        if (variant && variant.price) {
          state.basePrice = parseFloat(variant.price);
          updateTotalPrice();
           updateAddToCartButton(); // ✅ Add this
        }
      } catch (e) {
        console.error("Error parsing product JSON:", e);
      }
    }
  }

  // ✅ bundle 1 jaise — variant:change + bundleform2 change events
  function setupFormVariantListener() {
    const variantSelectors = document.querySelectorAll(
      '.bundleform2 select, .bundleform2 input[type="radio"]'
    );
    variantSelectors.forEach((selector) => {
      selector.addEventListener("change", () => {
        setTimeout(() => {
          updateBasePriceFromForm();
          updateAddToCartButton();
        }, 100);
      });
    });

    const hiddenInput = document.querySelector('.bundleform2 input[name="id"]');
    if (hiddenInput) {
      const observer = new MutationObserver(() => {
        updateBasePriceFromForm();
        updateAddToCartButton();
      });
      observer.observe(hiddenInput, { attributes: true, attributeFilter: ["value"] });
    }

    document.addEventListener('variant:change', () => {
      setTimeout(() => updateAddToCartButton(), 50);
    });

    document.addEventListener('change', (e) => {
      if (e.target.closest('.bundleform2')) {
        setTimeout(() => updateAddToCartButton(), 150);
      }
    });
  }

  function setupVariantChangeListener() {
    document.addEventListener("bundle:variantChanged2", function (e) {
      const { productType, newVariantId, newPrice } = e.detail;

      let existingKey = null;
      state.selectedItems.forEach((val, key) => {
        if (val.productType === productType) existingKey = key;
      });

      if (existingKey === null) return;

      const existingVal = state.selectedItems.get(existingKey);
      state.selectedItems.delete(existingKey);
      const newKey = `${productType}-${newVariantId}`;
      state.selectedItems.set(newKey, {
        ...existingVal,
        id: newVariantId,
        price: newPrice,
      });

      updateTotalPrice();
    });
  }

  function init() {
    disableAddToBundleButtons();
    setupEventListeners();
    setupFormVariantListener();
    updateBasePriceFromForm();
    setupVariantChangeListener();
     setTimeout(() => updateAddToCartButton(), 200);
  }

  function disableAddToBundleButtons() {
    elements2.addToBundleButtons.forEach((button) => {
      button.disabled = true;
      button.classList.add("disabled");
    });
  }

  function setupEventListeners() {
    setupDropdownToggles();
    setupItemSelection();
    setupAddToBundle();
    setupQuantityControls();
    setupBundleAddToCart();
    setupBuyNow();
  }

  // ────────────────────────────────────────────────
  // Add Bundle to Cart
  // ────────────────────────────────────────────────
  function setupBundleAddToCart() {
    if (!elements2.addToCart) return;
    elements2.addToCart.addEventListener("click", async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const mainVariantId = getMainVariantId();
      if (!mainVariantId) {
        console.error("Main product variant ID not found!");
        elements2.addToCart.textContent = "Error";
        setTimeout(() => { elements2.addToCart.innerHTML = "<span>Add Bundle to Cart</span>"; }, 1500);
        return;
      }

      const quantity = parseInt(elements2.quantity.input.value) || 1;

      let allItems = [
        { id: mainVariantId, quantity },
        ...[...state.selectedItems.values()]
          .filter(item => state.confirmedDropdowns.has(item.productType))
          .map((item) => {
            const domItem = document.querySelector(
              `.bundle-dropdown2[data-product-type="${item.productType}"] .bundle-dropdown-item2.selected`
            );
            const latestVariantId = domItem ? domItem.dataset.variantId : item.id;
            return { id: latestVariantId, quantity };
          }),
      ];

      // ✅ Sirf main product (index 0) mein preorder property
      const msg = getPreorderProperty();
      if (msg) {
        allItems[0].properties = { ...(allItems[0].properties || {}), 'Pre-Order': msg };
      }

      try {
        elements2.addToCart.textContent = "Adding...";
        elements2.addToCart.disabled = true;

        const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        const cartData = {
          items: allItems,
          sections: cart ? cart.getSectionsToRender().map((s) => s.id) : undefined,
          sections_url: window.location.pathname,
        };

        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(cartData),
        });

        if (!response.ok) throw new Error("Add to cart failed");
        const data = await response.json();

        if (typeof window.PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "bundle-form", cartData: data });
        }

        if (cart) {
          cart.renderContents(data);
          if (cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
        }

        elements2.addToCart.innerHTML = "Added!";
        setTimeout(() => {
          elements2.addToCart.innerHTML = '<span class="bundle-add-icon"></span> <span>Add Bundle to Cart</span>';
          elements2.addToCart.disabled = false;
        }, 1500);

        resetBundleState();
      } catch (error) {
        console.error("Error adding bundle:", error);
        elements2.addToCart.textContent = "Sold Out";
        setTimeout(() => {
          elements2.addToCart.innerHTML = "Sold Out";
          elements2.addToCart.disabled = false;
        }, 2000);
      }
    });
  }

  // ────────────────────────────────────────────────
  // Buy Now
  // ────────────────────────────────────────────────
  function setupBuyNow() {
    if (!elements2.buyNow) return;
    elements2.buyNow.addEventListener("click", handleBuyNow);
  }

  async function handleBuyNow(e) {
    e.preventDefault();
    e.stopPropagation();

    const mainVariantId = getMainVariantId();
    if (!mainVariantId) {
      console.error("Main variant ID not found for Buy Now!");
      elements2.buyNow.textContent = "Error";
      setTimeout(() => { elements2.buyNow.textContent = "Buy it now"; }, 2000);
      return;
    }

    const quantity = parseInt(elements2.quantity.input.value) || 1;

    let allItems = [
      { id: mainVariantId, quantity },
      ...[...state.selectedItems.values()]
        .filter(item => state.confirmedDropdowns.has(item.productType))
        .map((item) => {
          const domItem = document.querySelector(
            `.bundle-dropdown2[data-product-type="${item.productType}"] .bundle-dropdown-item2.selected`
          );
          const latestVariantId = domItem ? domItem.dataset.variantId : item.id;
          return { id: latestVariantId, quantity };
        }),
    ];

    // ✅ Sirf main product (index 0) mein preorder property
    const msg = getPreorderProperty();
    if (msg) {
      allItems[0].properties = { ...(allItems[0].properties || {}), 'Pre-Order': msg };
    }

    elements2.buyNow.textContent = "Processing...";
    elements2.buyNow.disabled = true;

    try {
      await fetch("/cart/clear.js", { method: "POST", credentials: "same-origin" });

      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: allItems }),
      });

      if (!addResponse.ok) throw new Error("Failed to add items");
      window.location.href = "/checkout";
    } catch (error) {
      console.error("Buy Now failed:", error);
      elements2.buyNow.textContent = "Try Again";
      setTimeout(() => {
        elements2.buyNow.textContent = "Buy it now";
        elements2.buyNow.disabled = false;
      }, 2000);
    }
  }

  function setupDropdownToggles() {
    elements2.dropdowns.forEach((dropdown) => {
      const header = dropdown.querySelector(".bundle-dropdown-header");
      const content = dropdown.querySelector(".bundle-dropdown-content");

      header.addEventListener("click", () => {
        const isOpen = content.classList.contains("open");
        closeAllDropdowns();
        if (!isOpen) {
          content.classList.add("open");
          header.classList.add("active");
        }
      });
    });
  }

  function closeAllDropdowns() {
    document.querySelectorAll(".bundle-dropdown-content").forEach((dc) => dc.classList.remove("open"));
    document.querySelectorAll(".bundle-dropdown-header").forEach((dh) => dh.classList.remove("active"));
  }

  function setupItemSelection() {
    document.querySelectorAll(".bundle-dropdown-item2").forEach((item) => {
      const checkbox = item.querySelector('.green-checkbox2 input[type="checkbox"]');

      if (checkbox) {
        checkbox.addEventListener("change", (event) => {
          event.stopPropagation();
          const dropdown = item.closest(".bundle-dropdown2");

          if (checkbox.checked) {
            uncheckOtherItemsInDropdown(dropdown, item);
            selectItem(item, dropdown, item.dataset.variantId);
          } else {
            const productType = dropdown.dataset.productType;
            const itemKey = `${productType}-${item.dataset.variantId}`;
            deselectItem(item, itemKey, dropdown);
          }

          updateUI(dropdown);
        });
      }

      item.addEventListener("click", (event) => {
        if (
          event.target.closest(".variant-selector-wrapper") ||
          event.target.tagName === "SELECT" ||
          event.target.tagName === "OPTION"
        ) {
          event.stopPropagation();
          return;
        }

        if (
          event.target.tagName === "INPUT" ||
          event.target.closest(".green-checkbox2")
        ) {
          event.stopPropagation();
          return;
        }

        event.stopPropagation();

        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event("change", { bubbles: false }));
        }
      });
    });
  }

  function uncheckOtherItemsInDropdown(dropdown, currentItem) {
    dropdown.querySelectorAll(".bundle-dropdown-item2").forEach((otherItem) => {
      if (otherItem === currentItem) return;

      const otherCheckbox = otherItem.querySelector('.green-checkbox2 input[type="checkbox"]');
      if (otherCheckbox) otherCheckbox.checked = false;

      if (otherItem.classList.contains("selected")) {
        const productType = dropdown.dataset.productType;
        const otherKey = `${productType}-${otherItem.dataset.variantId}`;
        otherItem.classList.remove("selected");
        state.selectedItems.delete(otherKey);
      }
    });
  }

  function selectItem(item, dropdown, variantId) {
    const productType = dropdown.dataset.productType;
    const price = parseFloat(item.dataset.price || 0);
    const title = item.dataset.productTitle || item.querySelector(".bundle-item-title").textContent;
    const isRequired = dropdown.dataset.required === "true";
    const itemKey = `${productType}-${variantId}`;

    dropdown.querySelectorAll(".bundle-dropdown-item2.selected").forEach((el) => {
      if (el === item) return;
      const otherVariantId = el.dataset.variantId;
      const otherItemKey = `${productType}-${otherVariantId}`;
      el.classList.remove("selected");
      state.selectedItems.delete(otherItemKey);
    });

    item.classList.add("selected");
    state.selectedItems.set(itemKey, {
      id: variantId,
      price: price,
      title: title,
      required: isRequired,
      productType: productType,
    });

    if (!state.confirmedDropdowns.has(productType)) {
      const selectedText = dropdown.querySelector(".bundle-dropdown-selected");
      if (selectedText) selectedText.textContent = title;
      dropdown.querySelector(".bundle-dropdown-header").classList.add("has-selection");
    }
  }

  function deselectItem(item, itemKey, dropdown) {
    item.classList.remove("selected");
    state.selectedItems.delete(itemKey);

    const checkbox = item.querySelector('.green-checkbox2 input[type="checkbox"]');
    if (checkbox) checkbox.checked = false;

    const productType = dropdown.dataset.productType;
    state.confirmedDropdowns.delete(productType);

    const hasOtherSelections = [...state.selectedItems.keys()].some(
      (key) => key.startsWith(`${productType}-`)
    );

    if (!hasOtherSelections) {
      const selectedText = dropdown.querySelector(".bundle-dropdown-selected");
      const arrowText = dropdown.querySelector(".bundle-dropdown-arrow");
      if (selectedText) selectedText.textContent = "Select options";
      if (arrowText) arrowText.textContent = "Select options";
      dropdown.querySelector(".bundle-dropdown-header").classList.remove("has-selection");

      const addBtn = dropdown.querySelector(".add-to-bundle-btn2");
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.classList.add("disabled");
      }
    }

    updateTotalPrice();
    updateSavingsDisplay();
    updateAddToCartButton();
    checkRequiredSelections();
  }

  function updateUI(dropdown) {
    updateTotalPrice();
    checkRequiredSelections();
    updateSavingsDisplay();
    updateAddToBundleButton(dropdown);
    updateAddToCartButton();
  }

  function setupAddToBundle() {
    elements2.addToBundleButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.stopPropagation();
        handleAddToBundle(button);
      });
    });
  }

  function handleAddToBundle(button) {
    const dropdown = button.closest(".bundle-dropdown2");
    const productType = dropdown.dataset.productType;

    const hasSelection = [...state.selectedItems.values()].some(
      (item) => item.productType === productType
    );
    if (!hasSelection) return;

    state.confirmedDropdowns.add(productType);
    closeDropdown(dropdown);
    showAddedConfirmation(dropdown, button);
    updateSavingsDisplay();
  }

  function closeDropdown(dropdown) {
    dropdown.querySelector(".bundle-dropdown-content").classList.remove("open");
    dropdown.querySelector(".bundle-dropdown-header").classList.remove("active");
  }

  function showAddedConfirmation(dropdown, button) {
    const selectedText = dropdown.querySelector(".bundle-dropdown-selected");
    const arrowText = dropdown.querySelector(".bundle-dropdown-arrow");

    if (selectedText) selectedText.textContent = "Added";
    if (arrowText) arrowText.textContent = "Added";
    dropdown.querySelector(".bundle-dropdown-header").classList.add("has-selection");

    const originalText = button.innerHTML;
    button.innerHTML = "Added!";
    setTimeout(() => (button.innerHTML = originalText), 1000);
  }

  function updateTotalPrice() {
    let total = state.basePrice;
    state.totalSavings = 0;

    state.selectedItems.forEach((item) => {
      const dropdown = document.querySelector(`[data-product-type="${item.productType}"]`);
      const enableSavings = dropdown?.dataset.enableSavings === "true";
      total += item.price;
      if (enableSavings) state.totalSavings += item.price;
    });

    elements2.totalPrice.textContent = formatMoney(total);
  }

  function updateSavingsDisplay() {
    const confirmedCount = state.confirmedDropdowns.size;

    let displayPercent = 0;
    if (confirmedCount === 1) displayPercent = 10;
    else if (confirmedCount === 2) displayPercent = 20;
    else if (confirmedCount >= 3) displayPercent = 30;

    const progressWidth = (displayPercent / 30) * 100;
    elements2.savings.progress.style.width = progressWidth + "%";
    elements2.savings.marker.style.left = displayPercent > 0 ? progressWidth + "%" : "20px";

    elements2.savings.amount.textContent =
      displayPercent > 0
        ? "Save " + displayPercent + "%"
        : elements2.bundleSelector.dataset.savingsText || "";
  }

  function checkRequiredSelections() {
    const requiredDropdowns = document.querySelectorAll('.bundle-dropdown2[data-required="true"]');
    let allSelected = true;

    requiredDropdowns.forEach((dropdown) => {
      const productType = dropdown.dataset.productType;
      const hasSelection = [...state.selectedItems.values()].some(
        (item) => item.productType === productType
      );
      if (!hasSelection) allSelected = false;
    });

    state.bundleComplete = allSelected;
  }

  // ✅ bundle 1 jaise — inventory check bhi hai
  function updateAddToCartButton() {
    const mainVariantId  = getMainVariantId();
    const qty            = parseInt(elements2.quantity.input.value) || 0;
    const variantExists  = !!mainVariantId;
    const isAvailable    = isMainVariantAvailable();

    const enabled = variantExists && qty >= 1 && isAvailable;

    if (elements2.addToCart) {
      elements2.addToCart.disabled = !enabled;
      elements2.addToCart.classList.toggle("disabled", !enabled);
      if (enabled) elements2.addToCart.removeAttribute('disabled');
    }

    if (elements2.buyNow) {
      elements2.buyNow.disabled = !enabled;
      elements2.buyNow.classList.toggle("disabled", !enabled);
      if (enabled) elements2.buyNow.removeAttribute('disabled');
    }
  }

  function updateAddToBundleButton(dropdown) {
    const productType = dropdown.dataset.productType;
    const addBtn = dropdown.querySelector(".add-to-bundle-btn2");
    if (!addBtn) return;

    const hasSelection = [...state.selectedItems.values()].some(
      (item) => item.productType === productType
    );

    addBtn.disabled = !hasSelection;
    addBtn.classList.toggle("disabled", !hasSelection);
  }

  function setupQuantityControls() {
    elements2.quantity.decrease.addEventListener("click", () => {
      const value = parseInt(elements2.quantity.input.value);
      if (value > 1) elements2.quantity.input.value = value - 1;
      updateAddToCartButton();
    });

    elements2.quantity.increase.addEventListener("click", () => {
      elements2.quantity.input.value = parseInt(elements2.quantity.input.value) + 1;
      updateAddToCartButton();
    });
  }

  function resetBundleState() {
    state.selectedItems = new Map();
    state.confirmedDropdowns = new Set();
    state.totalSavings = 0;
    state.bundleComplete = false;

    elements2.dropdowns.forEach((dropdown) => {
      const selectedText = dropdown.querySelector(".bundle-dropdown-selected");
      const arrowText = dropdown.querySelector(".bundle-dropdown-arrow");
      const header = dropdown.querySelector(".bundle-dropdown-header");
      if (selectedText) selectedText.textContent = "Select options";
      if (arrowText) arrowText.textContent = "Select options";
      if (header) header.classList.remove("has-selection");

      dropdown.querySelectorAll(".bundle-dropdown-item2.selected").forEach((item) => {
        item.classList.remove("selected");
        const cb = item.querySelector('.green-checkbox2 input[type="checkbox"]');
        if (cb) cb.checked = false;
      });
    });

    disableAddToBundleButtons();
    elements2.savings.progress.style.width = "0%";
    elements2.savings.marker.style.left = "20px";
    updateTotalPrice();
    updateSavingsDisplay();
    updateAddToCartButton();
  }

  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

 init();
setTimeout(() => updateAddToCartButton(), 300);
});
